module.exports = __webpack_public_path__ + "img/无.fbefa8c1.jpg";